<template>
  <div>
    <div class="row">
      <div class="col-md-12 header-row">
        <h3 v-if="bookId" class="heading semi-bold">Update Fabric Book</h3>
        <h3 v-else class="heading semi-bold">Create Fabric Book</h3>
      </div>
    </div>

    <div class="grid shadow bg-white mt-20">
      <div class="grid-title">
        <h4 v-if="bookId">Update Fabric Book</h4>
        <h4 v-else>Update Fabric Book</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <BookDetails
            :modelValue="modelValue"
            :fieldValues="fieldValues"
            :errors="errors"
            :bookCoverImage="modelValue.book_cover_image"
            :bookCoverENImage="modelValue.book_cover_image_en"
            :currentTopCategory="currentTopCategory"
            @sub-category-created="getBookCategories"
            @category-changed="onCategoryChanged"
            @cover-image-selected="setCoverImage"
            @en-cover-image-selected="setENCoverImage"
            ref="bookDetailsRef"
          >
          </BookDetails>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button
          class="btn-primary btn-large btn btn-block mb-15"
          @click="saveFabricBook()"
        >
          Save Book
        </button>
      </div>
    </div>
    <FabricSelectionPanel
      :modelValue="modelValue"
      ref="fabricSelectionRef"
    ></FabricSelectionPanel>

    <!-- Modal -->
    <div
      class="modal fade"
      id="cover-upload-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body bg-white">
            <p class="text-center">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br />
              Uploading book cover, this may take some time. Please wait ...
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import BookDetails from "./components/BookDetails";
import FabricSelectionPanel from "./components/FabricSelectionPanel";

export default {
  components: {
    BookDetails,
    FabricSelectionPanel,
  },
  data() {
    return {
      isReadOnlyUser: false,
      errors: {},
      allCategories: [],
      fieldValues: {
        title: null,
        topCategories: [],
        subCategories: [],
        siblingBooks: [],
        predefinedColors: [],
      },
      modelValue: {
        id: null,
        title: null,
        consultant_id: null,
        top_category_id: null,
        sub_category_id: null,
        fabric_book_category_id: null,
        visibility: "public",
        likes: 0,
        fabrics: [],
        book_cover_image: null,
        book_cover_image_en: null,
        book_cover_color: "#FFFFFF",
        selectedImage: null,
        selectedENImage: null,
        bookReferenceId: null,
        changeBookOrder: false,
        bookReferenceLocation: "after",
        fabricIds: [],
      },
      bookId: null,
      categoryId: null,
      selectedTopCategoryId: null,
      isUploading: false,
      currentTopCategory: {
        books: [],
        can_have_child: null,
        can_have_user_books: null,
        id: null,
        order: null,
        parent_fabric_book_category_id: null,
        slug: null,
        title: null,
      },
    };
  },
  async mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    if (this.$route.name === "fabric_book_create") {
      this.categoryId = parseInt(this.$route.params.id);
    } else {
      this.bookId = parseInt(this.$route.params.id);
    }

    await this.getBookCreationData();
    await this.getBookDetails();
    await this.getBookCategories();
    this.$refs.fabricSelectionRef.loadFabrics();
    this.$refs.bookDetailsRef.selectedCoverColor = {
      name: "",
      value: this.modelValue.book_cover_color,
    };

    if (!this.bookId) {
      this.modelValue.changeBookOrder = true;
    }
  },
  methods: {
    async getBookCreationData() {
      let results = await axios.get("/v2/fabrics/book/create");
      this.fieldValues.predefinedColors = results.data.data.cover_colors;
    },

    async getBookDetails() {
      if (this.bookId) {
        let results = await axios.get("/v2/fabrics/book/" + this.bookId);
        Object.assign(this.modelValue, results.data.data);

        // Convert this field to boolean if not the toggle button will trigger an error
        // this.modelValue.is_private = (this.modelValue.is_private === 1);
      }
    },
    async getBookCategories() {
      let results = await axios.get("/v2/fabrics/book-category");
      this.allCategories = results.data.data.collection;

      /**
       * Create the list of top categories
       */
      this.fieldValues.topCategories = this.allCategories.filter((category) => {
        return category.parent_fabric_book_category_id === null;
      });

      this.buildTopAndSubCategories();
    },

    onCategoryChanged(categoryId) {
      // Check if the selected category is a parent category
      let selectedTopCategory = this.fieldValues.topCategories.find(
        (category) => {
          return category.id === categoryId;
        }
      );

      if (selectedTopCategory) {
        this.selectedTopCategoryId = categoryId;
      }
      this.buildTopAndSubCategories();
    },
    /**
     * Create the list of sub-categories
     */
    buildTopAndSubCategories() {
      /**
       * Create the list of sub categories.
       * But first, we need to know which top category to select.
       * If a book is loaded, use that book category to define which top and sub category to select.
       */
      if (this.modelValue.sub_category_id) {
        this._setSelectedTopAndSubCategoryIds(this.modelValue.sub_category_id);
      } else {
        if (this.bookId) {
          this._setSelectedTopAndSubCategoryIds(
            this.modelValue.fabric_book_category_id
          );
        } else {
          // Check if the request category is a main or a sub category
          this._setSelectedTopAndSubCategoryIds(this.categoryId);
        }
      }

      /**
       * Now that we know which top category is selected, we can create the list of sub-category.
       */
      this.fieldValues.subCategories = this.allCategories.filter((category) => {
        return (
          category.parent_fabric_book_category_id ===
          this.modelValue.top_category_id
        );
      });

      if (!this.selectedTopCategoryId) {
        this.selectedTopCategoryId = this.modelValue.top_category_id;
      }

      this.getCategoryBooks();
    },
    /**
     * This helper function determine which top and sub category should be selected.
     * This will be used to create the list of sub-category
     */
    _setSelectedTopAndSubCategoryIds(categoryId) {
      this.allCategories.forEach((category) => {
        if (category.id === categoryId) {
          if (category.parent_fabric_book_category_id === null) {
            this.modelValue.top_category_id = this.selectedTopCategoryId
              ? this.selectedTopCategoryId
              : categoryId;
            this.modelValue.sub_category_id = null;
          } else {
            this.modelValue.top_category_id = this.selectedTopCategoryId
              ? this.selectedTopCategoryId
              : category.parent_fabric_book_category_id;
            this.modelValue.sub_category_id = category.id;
          }
        }
      });
    },
    /**
     * Get the list of books in the selected category.
     * This is used to display the book list dropdown, that allow the user to set the location of the book.
     */
    async getCategoryBooks() {
      let categoryId = this.getBookCategoryId();
      // let response = await axios.get(`v2/fabrics/book-category/${categoryId}/books`);
      let response = await axios.get(
        `v2/fabrics/book?categories=${categoryId}`
      );
      if (response.data.status === "OK") {
        this.fieldValues.siblingBooks = response.data.data.collection.filter(
          (book) => {
            return book.id !== this.bookId;
          }
        );
      }

      // set top category
      this.allCategories.forEach((category) => {
        if (category.id === this.selectedTopCategoryId) {
          this.currentTopCategory = category;
        }
      });

      // Select the last book as reference when creating a new book
      if (
        this.modelValue.id === null &&
        this.fieldValues.siblingBooks.length > 0
      ) {
        let lastBook = this.fieldValues.siblingBooks.at(-1);
        console.log(lastBook);
        this.modelValue.bookReferenceId = lastBook.id;
      }

      // Reset the previous book reference selection if no sibling book is available
      if (this.fieldValues.siblingBooks.length === 0) {
        this.modelValue.bookReferenceId = null;
      }
    },
    /**
     *
     */
    async saveFabricBook() {
      let data = {
        title: this.modelValue.title,
        fabric_book_category_id: this.getBookCategoryId(),
        visibility: this.modelValue.visibility,
        book_cover_color: this.modelValue.book_cover_color,
        change_order: false,
        book_ref_id: null,
        book_ref_location: null,
        fabrics: this.modelValue.fabricIds,
      };

      if (this.modelValue.changeBookOrder) {
        if (
          !this.modelValue.bookReferenceId &&
          this.fieldValues.siblingBooks.length > 0
        ) {
          toastr.error("Please select a reference book");
          return;
        }
        data.change_order = true;
        data.book_ref_id = this.modelValue.bookReferenceId;
        data.book_ref_location = this.modelValue.bookReferenceLocation;
      }

      /**
       * Update the current fabric book
       */
      if (this.bookId) {
        try {
          await axios
            .put("v2/fabrics/book/" + this.bookId, data)
            .then((response) => {
              if (response.data.status === "OK") {
                toastr.success("Fabric book successfully updated");
              } else {
                window.scrollTo(0, 0);
                this.errors = error.response.data.errors;
                //se.data.errors;
              }
            });
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
            this.errors = error.response.data.errors;
          }
          this.loading = false;
        }
      }

      /**
       * Create a new fabric book
       */
      if (!this.bookId) {
        try {
          await axios.post("v2/fabrics/book", data).then(async (response) => {
            if (response.data.status === "OK") {
              if (this.modelValue.selectedImage) {
                show_modal("#cover-upload-modal");
                try {
                  if (this.modelValue.selectedImage) {
                    const form = new FormData();
                    form.set("image", this.modelValue.selectedImage);
                    await axios.post(
                      `v2/fabrics/book/${response.data.data.id}/cover/de`,
                      form,
                      {
                        headers: { "Content-Type": "multipart/form-data" },
                      }
                    );
                  }

                  if (this.modelValue.selectedENImage) {
                    const form = new FormData();
                    form.set("image_en", this.modelValue.selectedENImage);
                    await axios.post(
                      `v2/fabrics/book/${response.data.data.id}/cover/en`,
                      form,
                      {
                        headers: { "Content-Type": "multipart/form-data" },
                      }
                    );
                  }

                  hide_modal("#cover-upload-modal");
                } catch (error) {
                  if (error.response.status === 422) {
                    // Error triggered by request validation
                    let errorMessage = error.response.data.message; // Set default error message
                    if (error.response.data.errors.hasOwnProperty("image")) {
                      errorMessage = error.response.data.errors["image"].join(
                        ", "
                      );
                    } else if (
                      error.response.data.errors.hasOwnProperty("image_en")
                    ) {
                      errorMessage = error.response.data.errors[
                        "image_en"
                      ].join(", ");
                    }
                    toastr.error(errorMessage);
                  } else if (error.response.status === 413) {
                    // Error triggered by HTTP server (Apache/Nginx) configutation
                    toastr.error("Image size is too large");
                  } else if (error.response.status === 403) {
                    toastr.error(
                      "Not authorized, please ensure that you have the required permissions."
                    );
                  } else {
                    toastr.error("Unknown error");
                  }
                }
              }

              toastr.success("Fabric book successfully created");

              this.$router.push({
                name: "fabric_book_list",
                params: {
                  category: data.fabric_book_category_id,
                },
              });
            } else {
              window.scrollTo(0, 0);
              this.errors = error.response.data.errors;
            }
          });
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
            this.errors = error.response.data.errors;
          }
          this.loading = false;
        }
      }
    },
    /**
     * Get the finale value of the category ID that should be assigned to the book as it's parent.
     * It should be the sub-category if set, the top-category otherwise.
     */
    getBookCategoryId() {
      return this.modelValue.sub_category_id
        ? this.modelValue.sub_category_id
        : this.modelValue.top_category_id;
    },

    setCoverImage(image) {
      this.modelValue.selectedImage = image;
    },

    setENCoverImage(image) {
      this.modelValue.selectedENImage = image;
    },
  },
};
</script>
